var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v("Create Company")]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            {
              class: _vm.$style.searchInputContainer,
              attrs: { "for-id": "accountId", error: _vm.$showError("name") },
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Enter Company Name"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                staticClass: "rbInput",
                class: _vm.$style.searchInput,
                attrs: {
                  id: "name",
                  name: "name",
                  "data-vv-as": "Company Name",
                  autocomplete: "off",
                  autofocus: "",
                },
                domProps: { value: _vm.name },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.name = $event.target.value
                    },
                    _vm.search,
                  ],
                },
              }),
              _c(
                "i",
                { staticClass: "material-icons", class: _vm.$style.searchIcon },
                [_vm._v(" search ")]
              ),
            ]
          ),
          _c("div", [
            _vm.companies.length > 0
              ? _c(
                  "label",
                  {
                    staticClass: "rbInputLabel",
                    class: _vm.$style.companiesLabel,
                  },
                  [
                    _c("span", [
                      _vm._v("Select your company from the list below"),
                    ]),
                    _c("span", [
                      _c("b", [_vm._v(_vm._s(_vm.resultCount))]),
                      _vm._v(" results found"),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.companies.length > 0
              ? _c(
                  "div",
                  { class: _vm.$style.companies },
                  [
                    _vm._l(_vm.companies, function (company, index) {
                      return _c(
                        "div",
                        {
                          key: company.id + index,
                          class: {
                            [_vm.$style.company]: true,
                            [_vm.$style.selected]:
                              _vm.data.companyId === company.id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggle(company.id)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("business"),
                          ]),
                          _c("div", [
                            _c("div", [_vm._v(_vm._s(company.name))]),
                            _c("span", [_vm._v(_vm._s(company.fullAddress))]),
                          ]),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("keyboard_arrow_right"),
                          ]),
                        ]
                      )
                    }),
                    _vm.companies.length > 0 &&
                    _vm.companies.length < _vm.resultCount
                      ? _c("div", { class: _vm.$style.loadMore }, [
                          _c(
                            "button",
                            {
                              staticClass: "rbButton mainButton",
                              attrs: { type: "button" },
                              on: { click: _vm.loadMore },
                            },
                            [_vm._v(" Load More ")]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "layout-column flex-center" },
                  [
                    _c("rbv-loading", {
                      attrs: { label: "Searching for your company..." },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.name && !_vm.selectedCompany
              ? _c("div", { class: _vm.$style.message }, [
                  _c("div", { class: _vm.$style.title }, [
                    _vm._v(" Can't find what your are looking for? "),
                  ]),
                  _c("span", [
                    _vm._v(
                      " Please check your spelling and change or remove some of the keywords. You can search by name, address, city, brand or chain. If you are still unable to find it, you can add it by clicking on the button below. "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _vm.selectedCompany
            ? _c(
                "button",
                {
                  staticClass: "rbButton mainButton",
                  attrs: { disabled: !_vm.name },
                  on: {
                    click: function ($event) {
                      _vm.action = "existing"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
                  _vm._v(" Continue "),
                ]
              )
            : _vm._e(),
          _vm.name
            ? _c(
                "button",
                {
                  staticClass: "rbButton",
                  class: _vm.selectedCompany ? _vm.$style.left : "",
                  on: {
                    click: function ($event) {
                      _vm.action = "new"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("create_new_folder"),
                  ]),
                  _vm._v(" Create New Company "),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }